<div class="imagine-one">
    <div class="container gennius">
        <div class="gennius__bloque">
            <div class="gennius__left">
                <div class="gennius__center">
                    <img src="./assets/img/imagine/one-app.webp" class="img_one">
                </div>
            </div>
            <div class="gennius__right">
                <div class="imagine-one_content">
                    <div class="content-one" [ngClass]="{'out': next}">
                        <img src="./assets/img/imagineAsOne/icon-image.png" alt="">
                        <div class="parragraf">
                            <p>
                                <span class="target"></span>
                                <span class="target2"></span>
                                <span class="target3"></span>
                            </p>
                            <p class="text-last">
                                <span class="target4"></span>
                            </p>
                        </div>

                        <button (click)="nextStep()">Continue</button>
                    </div>
                    <div class="content-two" [ngClass]="{'in': next}">
                        <div class="module">
                            <span class="icon-horn" (click)="muteVideo()" [ngClass]="{'mute': mute, 'in': next}"></span>
                            <div class="layout_home__block layout_home__block--navigator" [ngClass]="{'up': up}">
                                <div class="layout_home__buttons">
                                    <button [ngClass]="{'in': next}" (click)="openVideo('1')">
                                        Wallet
                                        <span>
                                            <img src="./assets/img/imagineAsOne/icon-wallet.png" alt="" class="image_icon">
                                        </span>
                                    </button>
                                    <!-- <button [ngClass]="{'in': next}" (click)="openVideo('2')">
                                        Programs
                                        <span>
                                            <img src="./assets/img/imagineAsOne/icon-programs.png" alt="" class="image_icon">
                                        </span>
                                    </button> -->
                                    <button [ngClass]="{'in': next}" (click)="openVideo('3')">
                                        Marketplace
                                       <span>
                                            <img src="./assets/img/imagineAsOne/icon-market.png" alt="" class="image_icon">
                                        </span>
                                    </button>
                                    <button [ngClass]="{'in': next}" (click)="openVideo('4')">
                                        Web3
                                        <span>
                                            <img src="./assets/img/imagineAsOne/icon-web.png" alt="" class="image_icon">
                                        </span>
                                    </button>
                                    <button [ngClass]="{'in': next}" (click)="openVideo('5')">
                                        The World as One
                                        <span>
                                            <img src="./assets/img/imagineAsOne/icon-asone.png" alt="" class="image_icon">
                                        </span>
                                    </button>
                                    <button [ngClass]="{'in': next}" (click)="openVideo('6')">
                                        Apple Vision Pro
                                        <span>
                                            <img src="./assets/img/imagineAsOne/icon-vision.png" alt="" class="image_icon">
                                        </span>
                                    </button>
                                </div>
                                <div class="layout_home__navigator">
                                    <img src="./assets/img/imagineAsOne/icon-image.png" alt="" class="image_icon" (click)="prevStep()">
                                    <div class="module_input" (click)="search()" [ngClass]="{'in': next}">
                                        <!-- <input placeholder="navigator" readonly [(ngModel)]="value"> -->
                                        <span [ngClass]="{'up': up}">{{value}}</span>
                                    </div>
                                </div>
                                <div class="search" [ngClass]="{'up': up}">
                                    <span class="expand">
                                        <span>Search for <strong>Emirates</strong> in Google</span>
                                    </span>
                                    <span class="image">
                                        <span>or ask <strong>allex</strong></span>
                                    </span>
                                    <img src="./assets/img/imagineAsOne/logo-emirates.png" alt="">
                                </div>
                            </div>


                            <div class="bg-video bg-video--one" [ngClass]="{'open': video1}">
                                <div class="poster-video">
                                    <video preload="none" class="video-1" (ended)="videoEnd('1')" playsinline="" poster="./assets/img/posters/post-wallet.png">
                                        <source
                                            src="https://imagineas.one/imagine/assets/videos/video-wallet.mp4" type="video/mp4">
                                    </video>
                                </div>
                                
                            </div>
                            <div class="bg-video bg-video--three" [ngClass]="{'open': video3}">
                                <div class="poster-video">
                                    <video preload="none" class="video-3" (ended)="videoEnd('3')" playsinline="" poster="./assets/img/posters/post-marketplace.png">
                                        <source
                                            src="https://imagineas.one/imagine/assets/videos/video-marketplace.mp4" type="video/mp4">
                                    </video>
                                </div>
                                
                            </div>

                            <div class="bg-video bg-video--four" [ngClass]="{'open': video4}">
                                <div class="poster-video">
                                    <video preload="none" class="video-4" (ended)="videoEnd('4')" playsinline="" poster="./assets/img/posters/post-web3.png">
                                        <source
                                            src="https://imagineas.one/imagine/assets/videos/video-web3.mp4" type="video/mp4">
                                    </video>
                                </div>
                                
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="filter"></div>
    <video preload="auto" autoplay="autoplay" loop="loop" playsinline="playsinline" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/gennius/poster-imagine.webp" muted>
        <source src="./assets/videos/video-bg.mp4" type="video/mp4">
    </video>
    <video preload="auto" class="video-sound" playsinline="" style="opacity: 0;" (ended)="videoEnd('7')">
        <source src="./assets/videos/audio-welcome.mp4" type="video/mp4">
    </video>
    <video preload="auto" class="video-navigator" style="opacity: 0;" playsinline="" (ended)="videoEnd('8')">
        <source src="./assets/videos/audio-navigator.mp4"type="video/mp4">
    </video>




    <div class="bg-video bg-video--five" [ngClass]="{'open': video5}" >
        <div class="v-rotate modal-general videointro">
                <!-- <div class="gif-rotate">
                <img src="./assets/img/posters/rotate.gif" alt="">
            </div> -->
            <video preload="none" class="video-5" (ended)="videoEnd('5')" playsinline="">
                <source src="https://imagineas.one/imagine/assets/videos/video-twao.mp4" type="video/mp4" >
            </video>
            <span class="icon-close" (click)="closeVideo('5')"></span>
        </div>
    </div>
    <div class="bg-video bg-video--six" [ngClass]="{'open': video6}">
        <div class="v-rotate modal-general videointro">
                <!-- <div class="gif-rotate">
                <img src="./assets/img/posters/rotate.gif" alt="">
            </div> -->
            <div class="poster-video-vision">
                <video preload="none" class="video-6" (ended)="videoEnd('6')" playsinline="" poster="./assets/img/posters/post-vision.png">
                    <source src="https://imagineas.one/imagine/assets/videos/video-visionpro.mp4" type="video/mp4">
                </video>
            </div>
            <span  class="icon-close" (click)="closeVideo('6')"></span>
        </div>
    </div>

    <span id="videoOne" style="display: none;" class="icon-close" (click)="closeVideo('1')"></span>
    <span id="videoTwo" style="display: none;" class="icon-close" (click)="closeVideo('3')"></span>
    <span id="videoFour" style="display: none;" class="icon-close" (click)="closeVideo('4')"></span>

    <app-connect></app-connect>

</div>


<section class="imagine_as_one">
    <div class="container">
        <img src="./assets/img/imagine/one-app.webp" class="img_one">
        <div class="imagine_as_one__module">
            <span>one currency</span>
            <span>one wallet</span>
            <span>one global marketplace</span>
        </div>
    </div>
</section>

<img src="./assets/img/gennius/cymi/element-41.webp" alt="gennius" class="elements">


<section class="five logo-cymi-aos imagine_explore" id="five">
    <div class="container">
        <div class="gennius__bloque">
            <div class="gennius__left">
                <h1>Explore the power of the Navigator</h1>
                <p>Your all-access key within our app. Simply type in what you need, and gain instant access to all app features and preferred merchants. </p>
                <div class="imagine_explore__navigator">
                    <img src="./assets/img/imagineAsOne/icon-image.png" alt="" class="image_icon">
                    <div class="module_input">
                        <span>{{value}}</span>
                    </div>
                </div>
            </div>
            <div class="gennius__right gennius__right--padding">
                    <img loading="lazy" class="iphone" src="./assets/img/imagine/phone-1.webp" alt="gennius">

            </div>
        </div>
        <img loading="lazy" *ngIf="!itsMobile" class="element elements_imagine" src="./assets/img/imagine/elements.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

    </div>

</section>



<section class="bl_colors">
    <section class="inverse-mobile four logo-cymi-aos section-digital" id="four">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" class="iphone-card" src="./assets/img/imagine/card.webp" alt="gennius">

                    <img loading="lazy" class="iphone" src="./assets/img/imagine/imagine-8.png" alt="gennius">

                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-10.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-11.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-12.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h1>Imagine Digital Card, the first card of its kind</h1>
                    <p>Redeem your rewards using the Imagine Digital Card at over 100 million merchants around the world.</p>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-17" src="./assets/img/gennius/cymi/element-14.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>


    </section>

    <section class="third imagine_shop">
        <h2>Imagine all of what you <br> own coming together as one.</h2>
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" class="shop-woman" src="./assets/img/cryptmi/say-hello3.png">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h2>Shop and redeem in app and in store worldwide.</h2>
                    <p>Split your payment to combine rewards, debit/credit cards, crypto, and pay in installments.</p>
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>

    <section class="five logo-cymi-aos imagine_wide" id="five">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <h1>A wide world of travel deals and benefits</h1>
                    <p>Access millions of travel deals at preferential rates and exclusive benefits in Expedia and partner airlines, as well as thousands of merchants.</p>

                </div>
                <div class="gennius__right gennius__right--padding">
                    <img loading="lazy" class="iphone" src="./assets/img/imagine/imagine-7.webp" alt="gennius">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-13.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-14.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-10" src="./assets/img/gennius/cymi/element-10.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-11" src="./assets/img/gennius/cymi/element-11.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-18" src="./assets/img/gennius/cymi/gif/element-7.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-19" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>

    </section>

    <section class="inverse-mobile six logo-cymi-aos imagine_super" id="six">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left gennius__left--padding">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-15.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-16.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h1>A super network of banks and digital sources</h1>
                    <p>The major e-wallets also play a critical role in ensuring interoperability. Apple Pay, Google Pay, and PayPal are among the capabilities incorporated to facilitate rewards transfer onto the system.</p>
                </div>
            </div>
            <img loading="lazy" class="element element-20" *ngIf="!itsMobile" src="./assets/img/gennius/cymi/element-14.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" class="element element-21" *ngIf="!itsMobile" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>

    <section class="three logo-cymi-aos imagine_over" id="three">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <h1>Over 1,800 cryptocurrencies<br> to choose from</h1>
                    <p>Switch your rewards to over 1,800 cryptocurrencies, and switch and swap between cryptocurrencies and loyalty points.</p>

                </div>
                <div class="gennius__right gennius__right--cero">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-7.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-8.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-9.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-7" src="./assets/img/gennius/cymi/gif/cubo-1.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='1' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-9" src="./assets/img/gennius/cymi/element-9.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>

    </section>

    <section class="second">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" class="phone-metaverse" src="./assets/img/imagine/phone-metaverse.webp">

                    <img loading="lazy" class="metaverse-element1" src="./assets/img/gennius/metaverse-elementX.webp">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h2>The<br>metaverse is<br>yours, too!</h2>
                    <p>Search, find and buy lands, avatars or anything in the metaverse.</p>
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-3" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>
</section>


<app-cymi-world (numberEmiter)="openVideo($event)"></app-cymi-world>

<section class="cymi-token">
    <img src="./assets/img/gennius/cymi/element-41.webp" alt="gennius" class="elements">

    <div class="container">
        <div class="row">
            <div class="left">
                <img loading="lazy" src="./assets/img/imagine/cymi-token-logo.webp" class="cymi-token-logo">
            </div>
            <div class="right">
                <h2>GMIX token</h2>
                <span class="text-gradient">We are establishing a <br> global hub for GMIX</span>
                <p>GMIX is a token that offers interoperability and instant swaps between loyalty programs, fiat currencies, and the crypto market, allowing users to pay for everyday essentials at over <span>100 million merchants around the world,</span> as well as for <span>NFTs</span> and purchases in the <span>Web3.</span>
                </p>
            </div>
        </div>

        <img loading="lazy" *ngIf="!itsMobile" class="element element-3" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
    </div>
    <img loading="lazy" *igIf="!itsMobile" src="./assets/img/gennius/cymi-token-element1.webp" class="cymi-token-element1">
</section>


<section class="bg-colors2">

    <section class="gennius--intro" id="intro-cymi">
        <div class="content">
            <h1>A token like no other</h1>
            <img loading="lazy" class="img-cymi" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
            <span class="text">Our proprietary token, GMIX, is a cryptoasset that runs on the Polygon blockchain, offering interoperability between loyalty programs, fiat currencies and the crypto market.</span>
            <!-- <button class="btn-gennius" (click)="openVideo('1')">Watch video</button> -->
        </div>
    </section>

    <app-animation-logo class="al"></app-animation-logo>

    <section class="one logo-cymi-aos imagine_conect" id="one">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <h1>Connect all your loyalty programs</h1>
                    <p>GMIX consolidates the entire digital asset ecosystem by allowing users to manage a wide array of financial instruments—including rewards programs, credit cards, debit cards, bank accounts, and cryptocurrencies—through a single interface.</p>
                </div>
                <div class="gennius__right gennius__right--cero">
                    <img loading="lazy" class="iphone" src="./assets/img/gennius/cymi/image-1.webp" alt="gennius">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-1.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-2.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-3.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">

                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-2" src="./assets/img/gennius/cymi/gif/cubo-5.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>


            <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>


            <img loading="lazy" *ngIf="!itsMobile" class="element element-14-gif" src="./assets/img/gennius/cymi/element-4.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>

    <section class="inverse-mobile two logo-cymi-aos imagine_super" id="two">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left gennius__left--cero">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-4.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-5.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-6.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
                <div class="gennius__right gennius__right">
                    <h1>Super connected. Fully interoperable.</h1>
                    <p>GMIX is connected to over 11,000 banks and Buy Now Pay Later platforms, enabling settlements in more than 180 global currencies.</p>
                </div>
            </div>


            <img loading="lazy" *ngIf="!itsMobile" class="element element-5" src="./assets/img/gennius/cymi/gif/cubo-5.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='1' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>



            <img loading="lazy" *ngIf="!itsMobile" class="element element-15" src="./assets/img/gennius/cymi/element-14.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>
</section>


<app-footer></app-footer>
